import Sortable from 'sortablejs'
export default class OrganizePictures {
  constructor (listPicture) {
    if (listPicture) {
      this.listPiture = listPicture
      const url = document.location.href.substring(0, document.location.href.lastIndexOf('posts')) + 'pictures/setposition'
      const btnDelete = document.querySelectorAll('.delete')
      /* eslint-disable no-unused-vars */
      const sortable = new Sortable(this.listPiture, {
        group: 'pictures',
        animation: 200,
        delay: 0,
        disabled: false,
        sort: true,
        filter: '.fake',
        store: {
          set: function (sortable) {
            const order = sortable.toArray()
            const result = Object.values(order)
            // ajax
            const httpRequest = new XMLHttpRequest()
            httpRequest.open('GET', url + '?results=' + JSON.stringify(result), true)
            httpRequest.send()
          }
        }

      })
      const httpRequest = new XMLHttpRequest()
      for (let i = 0; i < btnDelete.length; i++) {
        btnDelete[i].addEventListener('click', function (e) {
          e.preventDefault()
          const self = this
          httpRequest.onreadystatechange = function () {
            if (httpRequest.readyState === 4) {
              const currentPicture = self.parentNode.parentNode.parentNode
              const pictures = document.querySelectorAll('.picture')
              for (i = 0; i < pictures.length; i++) {
                if (pictures[i].dataset.position > currentPicture.dataset.position) {
                  const picture = pictures[i]
                  picture.dataset.position--
                }
              }
              currentPicture.classList.add('is-hidden')
              currentPicture.style.display = 'none'
              currentPicture.remove()
            }
          }
          httpRequest.open('GET', this.getAttribute('href'), true)
          httpRequest.send()
        })
      }
    }
  }
}
